import { getInspectorConfig } from "../Inspector/inspectorConfig";

const SUFFIX = ":cold-start-overlay";
const FALLBACK_NAMESPACE = "app";

function key(): string {
  // Reuse the Inspector's storage namespace so all dev-tool keys for an app
  // sit under the same prefix. Falls back when setInspectorConfig hasn't run
  // yet (e.g. unit tests that import this module without booting the app).
  try {
    return `${getInspectorConfig().storageNamespace}${SUFFIX}`;
  } catch {
    return `${FALLBACK_NAMESPACE}${SUFFIX}`;
  }
}

export function isColdStartOverlayEnabled(): boolean {
  return localStorage.getItem(key()) === "enabled";
}

export function setColdStartOverlayEnabled(enabled: boolean): void {
  if (enabled) {
    localStorage.setItem(key(), "enabled");
  } else {
    localStorage.removeItem(key());
  }
}
